import styled from "styled-components";
export const ErrorMessage = styled.small`
  color: ${({ theme }) => theme.colors.variant.danger};
`;
